module.exports = __webpack_public_path__ + "edc06f23893d2e64d2938891b119c176.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/AnimaReal_White@2x.png
// module id = 108
// module chunks = 0